import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button
} from "@chakra-ui/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

function DeleteDialog({ isOpen, onClose, onDelete, entityName }) {
  const cancelRef = useRef();
  const { t } = useTranslation("translation", {
    keyPrefix: "deleteDialog"
  });

  return (<AlertDialog
    isOpen={isOpen}
    leastDestructiveRef={cancelRef}
    onClose={onClose}
  >
    <AlertDialogOverlay>
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          {t("header", {entityName: entityName})}
        </AlertDialogHeader>

        <AlertDialogBody>
          {t("question")}
        </AlertDialogBody>

        <AlertDialogFooter>
          <Button ref={cancelRef} onClick={onClose}>
            {t("cancel")}
          </Button>
          <Button colorScheme="red" onClick={onDelete} ml={3}>
            {t("delete")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialogOverlay>
  </AlertDialog>);
}

export default DeleteDialog;